<template>
  <div>
    <TotalComplaints
      :styleWidth="'w-80'"
      :total="count"
      title="Total de entidades"
      body="entidades registradas"
    />
    <CompaniesEmisorasFilter
      :loading="loading"
      :searching="searching"
      @getFilterForm="setFilterForm"
    />
    <CompaniesEmisorasTable
      :dataSource="companiesEmisoras"
      @reload-data="reloadData"
    />
    <div class="p-4 flex justify-end">
      <a-pagination
        v-model="page"
        :page-size="pageSize"
        :page-size-options="pageSizeOptions"
        :total="count"
        show-size-changer
        size="large"
        @showSizeChange="onShowSizeChange"
        @change="onChange"
      />
    </div>
  </div>
</template>

<script>
import {
  DEFAULT_PAGE,
  DEFAULT_PAGE_SIZE,
} from "../../../../../core/utils/constants";
import TotalComplaints from "../../../../../components/Dashboard/Complaints/TotalComplaints.vue";
import CompaniesEmisorasFilter from "../partials/CompaniesEmisorasFilter.vue";
import CompaniesEmisorasTable from "../partials/CompaniesEmisorasTable.vue";
import companiesEmisoresServices from "@/feature/dashboard/companies-emisores/data/services/companies_emisores_services_impl";

export default {
  components: {
    TotalComplaints,
    CompaniesEmisorasTable,
    CompaniesEmisorasFilter,
  },
  data() {
    return {
      count: 0,
      loading: false,
      form: {},
      page: DEFAULT_PAGE,
      pageSize: DEFAULT_PAGE_SIZE,
      pageSizeOptions: ["50", "100", "150", "200", "250"],
      searching: false,
      companiesEmisoras: [],
    };
  },
  methods: {
    async setFilterForm(form, pagination) {
      this.form = form;
      if (pagination.page && pagination.pageSize) {
        this.page = pagination.page;
        this.pageSize = pagination.pageSize;
      }
      await this.fetchData();
    },
    async fetchData() {
      this.loading = true;
      this.searching = true;
      const pagination = {
        page: this.page,
        pageSize: this.pageSize,
      };

      try {         
        let formData = {
          ...this.form,
        };
 
        formData.is_active = "";
        if (this.form.is_active === "1" || this.form.is_active === "2") {
          formData.is_active = this.form.is_active === "1" ? true : false;
        }

        const { data } = await companiesEmisoresServices.getCompanyEmisores(
          pagination,
          formData
        );
        this.setDeafultEmited(data);
      } catch (error) {
        this.setDeafultEmited(null);
      } finally {
        this.loading = false;
        this.searching = false;
      }
    },
    async reloadData() {
      await this.fetchData();
    },
    setDeafultEmited(resp) {
      this.count = resp?.count || 0;
      const data = resp?.results || [];
      if (data.length > 0) {
        this.companiesEmisoras = data.map((element) => element);
      } else {
        this.companiesEmisoras = [];
      }
    },
    // Cambio de tamaño de página
    onShowSizeChange(page, page_size) {
      // Ante el cambio en el tamaño de la pagina se debe reiniciar la página a 1
      this.page = 1;
      this.pageSize = page_size;
      this.fetchData();
    },
    // Cambio de página
    onChange(page, page_size) {
      this.page = page;
      this.pageSize = page_size;
      this.fetchData();
    },
  },
};
</script>
